import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";

/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-27 16:16:24
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-06-12 15:32:07
 * @FilePath     : /marketing-landing-fe/src/modules/landing/BottomButton/index.ts
 * @Description  : 未添加文件描述
 */
import './index.less';
import storage from '@woulsl/storage';
import { ORDER_AREACODE } from '@/const';
import { _trans } from '@/lib/i18next';
import AreaCode from '@/plugins/AreaCode';
import Toast from '@/plugins/Toast';
import { isWXBrowser, moneyTransform, qsParse } from '@/utils';
import { canJsonParse } from '@/utils';
import { addClass } from '@/utils/dom';
import bus from '@/utils/eventemitter';
import { exposureModule, sensClick, sensClickInitiative } from '@/utils/sensors';

function getBtnTpl(type, _a) {
  if (type === void 0) {
    type = 1;
  }

  var moduleContent = _a.moduleContent,
      isNotFree = _a.isNotFree,
      minPrice = _a.minPrice,
      buttonStyle = _a.buttonStyle;
  var query = qsParse() || {};
  var inviteCode = query.inviteCode || '';
  var isWeChat = isWXBrowser();
  var price = moduleContent.split(','); // 20250317 https://t.xjjj.co/issues/331963 如果是动效按钮，判断是不是微信浏览器，微信环境统一走普通样式

  var btnType1Class = buttonStyle === 'BLINK' && !isWeChat ? 'btn-breath-text' : 'btn-text';
  var btn1text = isNotFree ? _trans('courseSelection.buy.btn') : _trans('courseSelection.free.btn');
  var btnType1 =
  /* html */
  "\n    <button data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u8D2D\u8BFE\u6309\u94AE\" data-element_target_url=\"".concat(inviteCode || '', "\" data-element_content=\"\u7ACB\u5373\u62A5\u540D\" data-activity_label=\"\u6295\u653E\" id=\"j-btn-buy\" class='").concat(btnType1Class, "'>\n      ").concat(moduleContent || btn1text, "\n    </button>");
  var btnType2 = "\n  <button data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u8D2D\u8BFE\u6309\u94AE\" data-element_target_url=\"".concat(inviteCode || '', "\" data-element_content=\"\u56FE\u7247\" id=\"j-btn-buy\" class=\"btn-img\">\n    <img src=\"").concat(moduleContent, "\" />\n  </button>\n  ");
  var btnType3 = "\n    <button data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u8D2D\u8BFE\u6309\u94AE\" \n    data-element_target_url=\"".concat(inviteCode || '', "\"\n    data-element_content=\"\u5355\u72EC\u8D2D\u4E70\" data-activity_label=\"\u6295\u653E\" id=\"j-btn-alone\" class=\"btn-alone\">\n      <span class=\"price\">").concat(__store._currency || '¥').concat(price[1], "</span>\n      <span class=\"text\">").concat(_trans('btnButton.btn.txt2'), "</span>\n    </button>\n    <button data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u8D2D\u8BFE\u6309\u94AE\" \n    \n    data-element_target_url=\"").concat(inviteCode || '', "\"\n    data-element_content=\"\u4E00\u952E\u53C2\u56E2\" data-activity_label=\"\u6295\u653E\" id=\"j-btn-immediately\" class=\"btn-immediately\">\n      <span class=\"price\">").concat(__store._currency || '¥').concat(price[0], "</span>\n      <span class=\"text\">").concat(_trans('btnButton.btn.txt3'), "</span>\n    </button>\n  ");
  var btnText = isNotFree ? _trans('courseSelection.receive.btn', {
    yuan: moneyTransform(minPrice)
  }) : _trans('courseSelection.free.btn');
  var btnType4 =
  /* html */
  "\n  <div class=\"btn-phone\">\n    <div class=\"inner\">\n    <button id=\"j-national-box\"></button>\n    <input class=\"i-phone j-i-phone\" placeholder=\"\u624B\u673A\u53F7\u4EC5\u4F5C\u4E3A\u4F53\u9A8C\u51ED\u8BC1\" type=\"input\" />\n    <button data-price=\"".concat(minPrice, "\" id=\"j-btn-buy2\" data-element_name=\"\u6295\u653E\u843D\u5730\u9875_\u8D2D\u8BFE\u6309\u94AE\" data-element_content=\"\u624B\u673A\u53F7\u9886\u53D6\" data-activity_label=\"\u6295\u653E\" class=\"i-btn\">").concat(btnText, "</button>\n    </div>\n  </div>\n  ");
  return [btnType1, btnType2, btnType3, btnType4][type ? type - 1 : type];
}

var Module = function () {
  function Module() {
    this.data = null;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  Module.prototype.mount = function ($root, _a) {
    var module = _a.module;
    var answerAbTestType = (this.data || {}).answerAbTestType;
    var btnBuy = document.getElementById('j-btn-buy');
    var btnBuy2 = document.getElementById('j-btn-buy2');
    var btnAlone = document.getElementById('j-btn-alone');
    var btnImm = document.getElementById('j-btn-immediately');

    if ($root) {
      addClass($root, 'pdbm136');
      addClass($root, 'root-blank');
    }

    var ac = new AreaCode('j-national-box', {
      code: qsParse().vAreaCode || storage.get(ORDER_AREACODE) || '+86',
      onChange: function onChange(code) {
        sensClickInitiative({
          $element_name: '投放落地页_购课按钮',
          $element_content: code,
          material_position: '投放落地页_区号选择',
          activity_label: '投放'
        });
      }
    });

    if (btnBuy2) {
      var $input = btnBuy2.previousElementSibling;

      $input.onfocus = function () {
        sensClickInitiative({
          $element_name: '投放落地页_购课按钮',
          // $element_content: ,
          material_position: '投放落地页_手机号输入',
          activity_label: '投放'
        });
      };

      btnBuy2.onclick = function (e) {
        sensClick(e);
        var input = btnBuy2.previousElementSibling;
        var phone = input.value;
        var minPrice = e.currentTarget.getAttribute('data-price');
        bus.emit('showPayWindow', {
          phone: phone,
          areaCode: ac.getCode(),
          minPrice: parseInt(minPrice || '0', 10)
        });
      };
    }

    if (btnBuy) {
      btnBuy.onclick = function (e) {
        sensClick(e);

        if (answerAbTestType) {
          bus.emit('toAnswerQuestion');
          return;
        }

        bus.emit('ChooseCourse');
      };
    }

    if (btnAlone) {
      btnAlone.onclick = function (e) {
        sensClick(e);
        Toast.info(_trans('btnButton.tips.joinGroup'), 1000, function () {
          bus.emit('ChooseCourse');
        });
      };
    }

    if (btnImm) {
      btnImm.onclick = function (e) {
        sensClick(e);
        bus.emit('ChooseCourse');
      };
    }

    var btnDom = btnBuy2 || btnBuy || btnAlone || btnImm;
    exposureModule(btnDom, {
      module: module
    });
  };

  Module.prototype.render = function (data, moduleResp) {
    this.data = data;
    var _a = data.skuMinOriginalPrice,
        skuMinOriginalPrice = _a === void 0 ? 0 : _a,
        _b = data.skuMinPrice,
        skuMinPrice = _b === void 0 ? 0 : _b,
        _c = data.frontCampaignSkuResps,
        frontCampaignSkuResps = _c === void 0 ? [] : _c;
    var minPrice = 1000;
    frontCampaignSkuResps.forEach(function (_a) {
      var price = _a.price;

      if (minPrice > price) {
        minPrice = price;
      }
    });
    var moduleLink = moduleResp.moduleLink,
        moduleSubType = moduleResp.moduleSubType,
        moduleContent = moduleResp.moduleContent,
        _d = moduleResp.moduleExtra,
        moduleExtra = _d === void 0 ? '' : _d;

    var _e = canJsonParse(moduleExtra),
        _f = _e.buttonStyle,
        buttonStyle = _f === void 0 ? '' : _f,
        _g = _e.buttonBg,
        buttonBg = _g === void 0 ? '' : _g,
        _h = _e.buttonImg,
        buttonImg = _h === void 0 ? '' : _h;

    var btnTpl =
    /* html */
    "\n    <section class=\"container buy-panel\">\n    <div class=\"btn\">\n      ".concat(getBtnTpl(moduleSubType, {
      moduleContent: [1, 2].includes(moduleSubType) ? moduleContent : "".concat(moneyTransform(skuMinPrice), ",").concat(moneyTransform(skuMinOriginalPrice)),
      moduleLink: moduleLink,
      isNotFree: minPrice > 0,
      minPrice: minPrice,
      buttonStyle: buttonStyle
    }), "\n    </div>\n    <div class=\"wx-hint\">\u53EB\u53EB\u9700\u8981\u60A8\u7684\u5FAE\u4FE1\u6388\u6743\uFF0C\u4EE5\u4FBF\u7ED9\u60A8\u7684\u8D26\u6237\u4E0B\u6DFB\u52A0\u4F53\u9A8C\u5185\u5BB9</div>\n   </section>");

    if (moduleSubType === 5) {
      document.body.classList.add('no-scroll'); // 弹窗形式 按钮组件

      return (
        /* html */
        "\n      <section class=\"containerV2 modal-btn-wrapper\">\n        <div class=\"modal-btn-bg\" style=\"background-image: url(".concat(buttonBg, ");\"></div>\n        <img class=\"modal-btn-img\" id=\"j-btn-buy\" alt='' src='").concat(buttonImg, "' />\n      </section>\n    ")
      );
    }

    return btnTpl;
  };

  return Module;
}();

export default new Module();